import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 d-flex justify-content-between align-items-center py-2" }
const _hoisted_4 = { class: "m-0 titulo cor_texto_1" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content"},
  class: "m-0 fas fa-arrow-left"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", { d: "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download text-red",
  style: {"font-size":"20px"}
}, null, -1)
const _hoisted_14 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "col-xl-6 p-3" }
const _hoisted_21 = {
  style: {"border-radius":"10px"},
  class: "card px-1 pt-1 pb-3"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\"><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><svg width=\"28\" height=\"26\" viewBox=\"0 0 30 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M29.2961 6.56251H25.7881L24.8131 4.125C23.8111 1.61895 21.4199 0 18.7205 0H11.2791C8.58027 0 6.18847 1.61895 5.18593 4.125L4.21093 6.56251H0.703499C0.245881 6.56251 -0.0898617 6.99259 0.0214666 7.43614L0.37303 8.84239C0.450959 9.15528 0.73221 9.37501 1.05506 9.37501H2.23104C1.44412 10.0623 0.937288 11.0613 0.937288 12.1875V15C0.937288 15.9446 1.29823 16.7971 1.87479 17.4569V20.625C1.87479 21.6604 2.71444 22.5 3.74979 22.5H5.62479C6.66015 22.5 7.4998 21.6604 7.4998 20.625V18.75H22.4998V20.625C22.4998 21.6604 23.3395 22.5 24.3748 22.5H26.2498C27.2852 22.5 28.1248 21.6604 28.1248 20.625V17.4569C28.7014 16.7977 29.0623 15.9451 29.0623 15V12.1875C29.0623 11.0613 28.5555 10.0623 27.7692 9.37501H28.9451C29.268 9.37501 29.5492 9.15528 29.6272 8.84239L29.9787 7.43614C30.0895 6.99259 29.7537 6.56251 29.2961 6.56251ZM8.66757 5.51778C9.09472 4.4502 10.1289 3.75 11.2791 3.75H18.7205C19.8707 3.75 20.9049 4.4502 21.332 5.51778L22.4998 8.43751H7.4998L8.66757 5.51778ZM5.62479 14.9883C4.49979 14.9883 3.74979 14.2406 3.74979 13.1192C3.74979 11.9977 4.49979 11.25 5.62479 11.25C6.7498 11.25 8.4373 12.9322 8.4373 14.0537C8.4373 15.1752 6.7498 14.9883 5.62479 14.9883ZM24.3748 14.9883C23.2498 14.9883 21.5623 15.1752 21.5623 14.0537C21.5623 12.9322 23.2498 11.25 24.3748 11.25C25.4998 11.25 26.2498 11.9977 26.2498 13.1192C26.2498 14.2406 25.4998 14.9883 24.3748 14.9883Z\" fill=\"#203972\"></path><path d=\"M8.66754 5.51778C9.09468 4.4502 10.1289 3.75 11.2791 3.75H18.7205C19.8707 3.75 20.9049 4.4502 21.332 5.51778L22.4998 8.43751H7.49976L8.66754 5.51778ZM5.62476 14.9883C4.49976 14.9883 3.74976 14.2406 3.74976 13.1192C3.74976 11.9977 4.49976 11.25 5.62476 11.25C6.74976 11.25 8.43726 12.9322 8.43726 14.0537C8.43726 15.1752 6.74976 14.9883 5.62476 14.9883ZM24.3748 14.9883C23.2498 14.9883 21.5623 15.1752 21.5623 14.0537C21.5623 12.9322 23.2498 11.25 24.3748 11.25C25.4998 11.25 26.2498 11.9977 26.2498 13.1192C26.2498 14.2406 25.4998 14.9883 24.3748 14.9883Z\" fill=\"#203972\"></path></svg></div><div class=\"\"><p class=\"m-0 subtitulo cor_texto_1\">Informações do veículo</p><p style=\"font-size:11px;\" class=\"m-0 legenda text-muted\">Edite mais detalhes do veículo</p></div></div><div class=\"px-5\"><hr class=\"text-muted m-0\"></div>", 2)
const _hoisted_24 = { class: "d-flex row p-5 align-items-center" }
const _hoisted_25 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Placa:", -1)
const _hoisted_27 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Marca:", -1)
const _hoisted_29 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Modelo:", -1)
const _hoisted_31 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Ano:", -1)
const _hoisted_33 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Km:", -1)
const _hoisted_35 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Fipe:", -1)
const _hoisted_37 = { class: "col-xl-6 p-3" }
const _hoisted_38 = {
  style: {"border-radius":"10px"},
  class: "card px-1 pt-1 pb-3"
}
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-5 align-items-center\"><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><svg width=\"28\" height=\"26\" viewBox=\"0 0 22 25\" fill=\"#203972\" xmlns=\"http://www.w3.org/2000/svg\"><path opacity=\"0.3\" d=\"M10.9375 12.5C14.3896 12.5 17.1875 9.70215 17.1875 6.25C17.1875 2.79785 14.3896 0 10.9375 0C7.48535 0 4.6875 2.79785 4.6875 6.25C4.6875 9.70215 7.48535 12.5 10.9375 12.5ZM15.3125 14.0625H14.4971C13.4131 14.5605 12.207 14.8438 10.9375 14.8438C9.66797 14.8438 8.4668 14.5605 7.37793 14.0625H6.5625C2.93945 14.0625 0 17.002 0 20.625V22.6562C0 23.9502 1.0498 25 2.34375 25H19.5312C20.8252 25 21.875 23.9502 21.875 22.6562V20.625C21.875 17.002 18.9355 14.0625 15.3125 14.0625Z\"></path><path d=\"M15.3125 14.0625H14.4971C13.4131 14.5605 12.207 14.8438 10.9375 14.8438C9.66797 14.8438 8.4668 14.5605 7.37793 14.0625H6.5625C2.93945 14.0625 0 17.002 0 20.625V22.6562C0 23.9502 1.0498 25 2.34375 25H19.5312C20.8252 25 21.875 23.9502 21.875 22.6562V20.625C21.875 17.002 18.9355 14.0625 15.3125 14.0625Z\"></path></svg></div><div class=\"\"><p class=\"m-0 subtitulo cor_texto_1\">Informações do cliente</p><p style=\"font-size:11px;\" class=\"m-0 legenda text-muted\">Edite mais detalhes do cliente</p></div></div><div class=\"px-5\"><hr class=\"text-muted m-0\"></div>", 2)
const _hoisted_41 = { class: "d-flex row p-5 align-items-center" }
const _hoisted_42 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Nome:", -1)
const _hoisted_44 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Documento:", -1)
const _hoisted_46 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Email:", -1)
const _hoisted_48 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Telefone:", -1)
const _hoisted_50 = { class: "col-12 p-3" }
const _hoisted_51 = {
  style: {"border-radius":"10px"},
  class: "card px-1 pt-1 pb-3"
}
const _hoisted_52 = { class: "d-flex justify-content-between gap-4 p-5 align-items-center w-100" }
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-row gap-4 align-items-center\"><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><svg width=\"28\" height=\"26\" fill=\"#203972\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5,4 L19,4 C19.2761424,4 19.5,4.22385763 19.5,4.5 C19.5,4.60818511 19.4649111,4.71345191 19.4,4.8 L14,12 L14,20.190983 C14,20.4671254 13.7761424,20.690983 13.5,20.690983 C13.4223775,20.690983 13.3458209,20.6729105 13.2763932,20.6381966 L10,19 L10,12 L4.6,4.8 C4.43431458,4.5790861 4.4790861,4.26568542 4.7,4.1 C4.78654809,4.03508894 4.89181489,4 5,4 Z\"></path></svg></div><div class=\"\"><p class=\"m-0 subtitulo cor_texto_1\">Informações do Atendimento</p><p style=\"font-size:11px;\" class=\"m-0 legenda text-muted\">Edite mais detalhes do atendimento</p></div></div>", 1)
const _hoisted_54 = { class: "d-flex flex-column gap-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 8 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0.931763 16.5714H1.71301V10.9286H0.931763C0.500278 10.9286 0.150513 10.5788 0.150513 10.1473V8.28125C0.150513 7.84977 0.500278 7.5 0.931763 7.5H5.30676C5.73825 7.5 6.08801 7.84977 6.08801 8.28125V16.5714H6.86926C7.30075 16.5714 7.65051 16.9212 7.65051 17.3527V19.2188C7.65051 19.6502 7.30075 20 6.86926 20H0.931763C0.500278 20 0.150513 19.6502 0.150513 19.2188V17.3527C0.150513 16.9212 0.500278 16.5714 0.931763 16.5714ZM3.90051 0C2.34719 0 1.08801 1.25918 1.08801 2.8125C1.08801 4.36582 2.34719 5.625 3.90051 5.625C5.45383 5.625 6.71301 4.36582 6.71301 2.8125C6.71301 1.25918 5.45379 0 3.90051 0Z" })
], -1)
const _hoisted_56 = {
  key: 0,
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-search"
}
const _hoisted_57 = {
  key: 1,
  style: {"color":"#fefefe"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "px-5" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1)
const _hoisted_61 = { class: "d-flex row p-5 align-items-center" }
const _hoisted_62 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Responsável:", -1)
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Valor original:", -1)
const _hoisted_67 = {
  disabled: "true",
  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
  class: "p-2"
}
const _hoisted_68 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Status do atendimento:", -1)
const _hoisted_70 = { class: "d-flex gap-4" }
const _hoisted_71 = {
  key: 0,
  class: "pago"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", null, "Pago", -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgba(27, 197, 189, 0.3)"},
  class: "rounded d-flex justify-content-center align-items-center px-3"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    fill: "#1BC5BD ",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" })
  ])
], -1)
const _hoisted_75 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Valor do desconto total:", -1)
const _hoisted_77 = {
  disabled: "true",
  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
  class: "p-2"
}
const _hoisted_78 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Status da integração:", -1)
const _hoisted_80 = { class: "d-flex gap-4" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgba(255, 193, 7, 0.3)"},
  class: "rounded d-flex justify-content-center align-items-center px-3"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    fill: "#ffc107",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" })
  ])
], -1)
const _hoisted_82 = { class: "col-6 d-flex flex-column gap-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1 texto" }, "Valor:", -1)
const _hoisted_84 = {
  disabled: "true",
  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
  class: "p-2"
}
const _hoisted_85 = { class: "col-12 d-flex flex-column gap-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "cor_texto_1" }, "Observação:", -1)
const _hoisted_87 = { class: "col-12 d-flex justify-content-between align-items-center py-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 subtitulo cor_texto_1" }, "Itens do atendimento", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"22px"},
  class: "m-0 fas fa-plus"
}, null, -1)
const _hoisted_90 = { class: "col-12 p-3" }
const _hoisted_91 = {
  style: {"border-radius":"10px"},
  class: "card d-flex p-0 overflow-hidden"
}
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div style=\"background:#203972;\" class=\"row p-5\"><div class=\"col-2\"><p class=\"text-white subtitulo m-0\">Cod</p></div><div class=\"col-3\"><p class=\"text-white subtitulo m-0\">Descrição</p></div><div class=\"col-1\"><p class=\"text-white subtitulo m-0\">Qtd</p></div><div class=\"col-2\"><p class=\"text-white subtitulo m-0\">Status</p></div><div class=\"col-2\"><p class=\"text-white subtitulo m-0\">Valor (R$)</p></div><div class=\"col-2\"><p class=\"text-white subtitulo m-0\">Ações</p></div></div>", 1)
const _hoisted_93 = { class: "col-2" }
const _hoisted_94 = { class: "p-2 w-100 d-inline-block text-truncate texto" }
const _hoisted_95 = { class: "col-3" }
const _hoisted_96 = { class: "p-2 w-100 d-inline-block text-truncate texto" }
const _hoisted_97 = { class: "col-1" }
const _hoisted_98 = { class: "p-2 w-100 d-inline-block text-truncate texto" }
const _hoisted_99 = { class: "col-2" }
const _hoisted_100 = { class: "p-2 w-100 d-inline-block text-truncate texto" }
const _hoisted_101 = { class: "col-2" }
const _hoisted_102 = { class: "p-2 w-100 d-inline-block text-truncate texto" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-pencil-alt"
}, null, -1)
const _hoisted_104 = {
  key: 1,
  class: "card p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_EditItemModal = _resolveComponent("EditItemModal")!
  const _component_ModalJSONIntegracao = _resolveComponent("ModalJSONIntegracao")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.store?.nomeFantasia) + " > Atendimento > " + _toDisplayString(_ctx.attendanceId), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              type: "button",
              text: "Voltar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.history.back()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "button",
              text: "Transmitir",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.transmit()))
            }, {
              default: _withCtx(() => [
                (_ctx.loadTransmit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                (!_ctx.loadTransmit)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "button",
              onClick: _ctx.downloadAtendimento
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              type: "button",
              text: "Salvar",
              variant: "secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveAttendance()))
            }, {
              default: _withCtx(() => [
                (_ctx.loadSave)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true),
                (!_ctx.loadSave)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.attendance.placa) = $event))
                }, null, 512), [
                  [_directive_maska, {
                mask: 'AAA-****',
                tokens: { '*': { pattern: /[a-zA-Z0-9]/, uppercase: true } },
              }],
                  [_vModelText, _ctx.attendance.placa]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.attendance.marca,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attendance.marca) = $event)),
                  placeholder: "Selecione um status",
                  clearable: "",
                  class: "w-100 border-0 customSelect"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleBrandArray, (brand, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: brand,
                        value: brand,
                        key: key
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(brand), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.attendance.veiculo) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.veiculo]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","text-align":"center"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.attendance.ano) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.ano]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.attendance.km) = $event))
                }, null, 512), [
                  [_directive_maska, { mask: '######' }],
                  [_vModelText, _ctx.attendance.km]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.attendance.fipe) = $event))
                }, null, 512), [
                  [_directive_maska, { mask: '#######-#' }],
                  [_vModelText, _ctx.attendance.fipe]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.attendance.cliente) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.cliente]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.attendance.documento) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.documento]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.attendance.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.attendance.telefone) = $event))
                }, null, 512), [
                  [_directive_maska, ['(##) #####-####', '(##) ####-####']],
                  [_vModelText, _ctx.attendance.telefone]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_Button, {
                  type: "button",
                  text: "Histórico integração",
                  variant: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.buscaJson(_ctx.attendance.codConcessionaria)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_55
                  ]),
                  _: 1
                }),
                (_ctx.codGrupo)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "button",
                      text: "Buscar integração",
                      variant: "primary",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getStatusAtendimentoIntegracao(_ctx.attendance.id, _ctx.attendance.codConcessionaria, 'conecta')))
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.loaderStore.status)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_56))
                          : (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("input", {
                  style: {"border":"1.5px solid #dbdbdb","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  onChange: _cache[15] || (_cache[15] = (e) => _ctx.attendance.responsavel = e.target.value),
                  value: _ctx.attendance?.responsavel
                }, null, 40, _hoisted_64)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, " R$ " + _toDisplayString(_ctx.attendance.valorDesconto !== '' ? (Number(_ctx.attendance.valorDesconto) + _ctx.attendance.valorOriginal!) : _ctx.attendance.valorOriginal || "00.00"), 1)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.attendance.status,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.attendance.status) = $event)),
                    placeholder: "Selecione um status",
                    clearable: "",
                    class: "w-100 border-0 customSelect"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusAttendance, (status, key) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: status,
                          value: status,
                          key: key
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(status), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.attendance.pago == '1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73))
                    : _createCommentVNode("", true),
                  _hoisted_74
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                _createElementVNode("div", _hoisted_77, " R$ " + _toDisplayString(_ctx.attendance.valorDesconto || "00.00"), 1)
              ]),
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    placeholder: "Selecione...",
                    clearable: "",
                    class: "w-100 border-0 customSelect",
                    modelValue: _ctx.attendance.statusIntegracao,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.attendance.statusIntegracao) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Transmitido",
                        value: "transmitido"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Não Transmitido",
                        value: "naoTransmitido"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_81
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, "R$ " + _toDisplayString(_ctx.attendance.valor || "00.00"), 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _withDirectives(_createElementVNode("textarea", {
                  maxlength: "300",
                  style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.attendance.observacao) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.attendance.observacao]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_87, [
          _hoisted_88,
          _createVNode(_component_Button, {
            type: "button",
            variant: "secondary",
            text: "Adicionar item",
            onClick: _cache[19] || (_cache[19] = () => {_ctx.openModal();})
          }, {
            default: _withCtx(() => [
              _hoisted_89
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            (!_ctx.loadingItemList)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.itensArray, (item, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "listaZebra row p-5",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, _toDisplayString(item.codItemLoja || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, _toDisplayString(item.nome || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, _toDisplayString(item.qtd || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, _toDisplayString(item.status || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, "R$ " + _toDisplayString(item.valor || "-"), 1)
                    ]),
                    _createVNode(_component_Button, {
                      type: "button",
                      text: "Editar",
                      variant: "primary",
                      onClick: () => _ctx.getItem(item.id),
                      class: "col-2",
                      style: {"max-width":"10rem"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_103
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createVNode(_component_el_skeleton, {
                    animated: "",
                    rows: 10
                  })
                ]))
          ])
        ])
      ])
    ]),
    _createVNode(_component_EditItemModal, {
      closeModal: _ctx.closeModal,
      getItens: _ctx.getItens
    }, null, 8, ["closeModal", "getItens"]),
    _createVNode(_component_ModalJSONIntegracao, {
      codConcessionaria: _ctx.codConcessionaria,
      idAtendimento: _ctx.attendanceId || undefined,
      cleanModal: _ctx.cleanModal,
      nomeEmpresa: _ctx.store?.nomeFantasia,
      jsonIntegracao: _ctx.jsonIntegracao,
      auxModal: _ctx.auxModal,
      clicked: _ctx.clicked
    }, null, 8, ["codConcessionaria", "idAtendimento", "cleanModal", "nomeEmpresa", "jsonIntegracao", "auxModal", "clicked"])
  ], 64))
}